<template>
    <generic-task-execution-modal
        :asset="asset"
        :curie-id="curieId"
        :assignable-users="assignableUsers"
        :description="description"
        :form="form"
        :presence-from-start-here-scan="presenceFromStartHereScan"
        :requires-presence-detection="requiresPresenceDetection"
        :task-resolved="taskResolved"
        :editable="editable"
        :task-code="taskCode"
        :task-group="taskGroup"
        :task-id="taskId"
        :title="title"
        @submit="handleSubmit"
    >
        <alert v-if="editable && curieIdPresenceDetected === false && !requiresPresenceDetection" color="warning">{{
            trans('test_records.qr_code_not_scanned.warning')
        }}</alert>

        <row class="mt-9">
            <column class="flex justify-center gap-4">
                <div>
                    <button
                        id="btn-report-success"
                        :class="{
                            'btn--selected': form.resolution === 'success',
                        }"
                        :disabled="!editable"
                        :style="{
                            opacity: form.resolution === 'success' ? 1 : 0.3,
                        }"
                        class="btn btn-icon btn-icon-lg bg-success-subtle border-success-subtle text-success-emphasis h-20! w-20! p-8"
                        @click.prevent="reportSuccess()"
                    >
                        <icon icon="cil-check" size="xl" />
                    </button>
                    <div>
                        <div class="text-success-emphasis p1 m-0 text-center">
                            {{ trans('test_record.form.success.button.label') }}
                        </div>
                    </div>
                </div>
                <div>
                    <button
                        id="btn-report-error"
                        :class="{
                            'btn--selected': form.resolution === 'fail',
                        }"
                        :disabled="!editable"
                        :style="{
                            opacity: form.resolution === 'fail' ? 1 : 0.3,
                        }"
                        class="btn btn-icon btn-icon-lg bg-danger-subtle border-danger-subtle text-danger-emphasis h-20! w-20! p-8"
                        @click.prevent="reportError()"
                    >
                        <icon icon="cil-medical-cross" style="transform: rotate(45deg)" />
                    </button>
                    <div>
                        <div class="text-danger-emphasis p1 m-0 text-center">
                            {{ trans('test_record.form.fail.button.label') }}
                        </div>
                    </div>
                </div>
            </column>
        </row>
        <row v-if="form.errors.resolution">
            <column>
                <div v-for="(message, key) in form.errors" :key="key">
                    <small class="text-danger">{{ message }}</small>
                </div>
            </column>
        </row>
    </generic-task-execution-modal>
</template>
<script setup>
import { defineAsyncComponent } from 'vue';
import Alert from '@/Components/Alert.vue';
import { useForm } from '@inertiajs/vue3';
import { trans } from '@/mixins/i18n';
const GenericTaskExecutionModal = defineAsyncComponent(() => import('@/Pages/Modals/GenericTaskExecutionModal.vue'));

const props = defineProps({
    asset: {
        type: Object,
        required: true,
    },
    curieIdPresenceDetected: {
        type: Boolean,
        required: true,
    },
    requiresPresenceDetection: {
        type: Boolean,
        default: false,
    },
    presenceFromStartHereScan: {
        type: Boolean,
        default: false,
    },
    curieId: {
        type: String,
        default: null,
    },
    title: String,
    description: String,
    taskId: String,
    taskCode: String,
    taskType: String,
    taskGroup: String,
    assetId: String,
    editable: {
        type: Boolean,
        default: false,
    },
    testRecord: Object,
    assignableUsers: Object,
    currentUserId: String,
    links: Object,
    existingPerformedById: String,
    taskResolved: { type: Boolean, default: false },
});

const emit = defineEmits(['created']);

const form = useForm({
    resolution: props.testRecord?.resolution?.value ?? undefined,
    description: props.testRecord?.description ?? '',
    attachments: [],
    performedById: props.existingPerformedById ?? props.currentUserId,
    taskId: props.taskId,
    task_type: props.taskType,
    asset_id: props.assetId,
});

const handleSubmit = (modal) => {
    form.post(props.links.create, {
        preserveScroll: true,
        onSuccess: () => {
            modal.emit('created', {
                assetId: props.asset.id,
                ...form.data(),
            });

            modal.close();
        },
    });
};
const reportSuccess = () => {
    form.resolution = 'success';
};
const reportError = () => {
    form.resolution = 'fail';
};
</script>
<style lang="scss" scoped>
.btn-round {
    border-radius: 50%;
    width: 75px;
    height: 75px;
    box-shadow: none;
    border: 4px solid #2eb85c;
    background: #fff;
    color: #2eb85c;
    outline: none;
    opacity: 0.25;

    .c-icon {
        width: 3rem !important;
        height: 3rem !important;
    }

    &.btn-round--red {
        border-color: #e55353;
        color: #e55353;
    }

    &.btn--selected {
        opacity: 1;
    }
}
</style>
